import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import BlogSection from './components/BlogSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="Mulebuy Spreadsheet – The Ultimate Guide to Smarter Cross-Border Shopping"
        description="Discover the complete Mulebuy Spreadsheet guide for smarter cross-border shopping. Learn how the Mulebuy Spreadsheet system helps you source products faster, compare prices, and streamline global shopping workflows. Updated for 2026 with guides, comparisons, and safety tips."
        keywords="mulebuy spreadsheet, cross-border shopping guide, product sourcing spreadsheet, mulebuy guide, shopping workflow"
        path="/"
        type="website"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <CTASection />
        <FeaturesSection />
        <AboutSection />
        <BlogSection />
        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
}